(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["oku-livraison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oku-livraison')) {
    customElements.define(
      'oku-livraison',
      class OkuLivraison extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10);
          const max = parseInt(this.dataset.max, 10);
          const cible = this.querySelector('[data-oku-livraison]');
          if (!cible || Number.isNaN(min) || Number.isNaN(max)) return;

          const ajouterJoursOuvres = (depart, jours) => {
            const date = new Date(depart);
            let restants = jours;
            while (restants > 0) {
              date.setDate(date.getDate() + 1);
              const jour = date.getDay();
              if (jour !== 0 && jour !== 6) restants -= 1;
            }
            return date;
          };

          const aujourdhui = new Date();
          const debut = ajouterJoursOuvres(aujourdhui, min);
          const fin = ajouterJoursOuvres(aujourdhui, Math.max(min, max));
          const jour = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric' });
          const jourMois = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
          const memeMois = debut.getMonth() === fin.getMonth();

          cible.textContent = `Livré entre le ${(memeMois ? jour : jourMois).format(debut)} et le ${jourMois.format(fin)}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["oku-promesse"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oku-promesse')) {
    customElements.define(
      'oku-promesse',
      class OkuPromesse extends HTMLElement {
        connectedCallback() {
          const angle = new URLSearchParams(window.location.search).get('angle');
          if (!angle) return;
          try {
            const textes = JSON.parse(this.dataset.angles || '{}');
            const texte = textes[angle];
            const cible = this.querySelector('.oku-promesse__texte');
            if (texte && cible) cible.textContent = texte;
          } catch (erreur) {
            /* promesse par défaut conservée */
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
